<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户名称</label>
            <span class="weui-form-preview__value">{{initData.sd_custname}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">采购员</label>
            <span class="weui-form-preview__value">{{initData.sd_buyername}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">确认状态</label>
            <span class="weui-form-preview__value">{{initData.sd_turnstatus}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">业务状态</label>
            <span class="weui-form-preview__value">{{initData.sd_bussStatus}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">订单日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.sd_date}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户PO</label>
            <span class="weui-form-preview__value">{{initData.sd_pocode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">行号</label>
            <span class="weui-form-preview__value">{{initData.sd_detno}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">类型</label>
            <span class="weui-form-preview__value">{{initData.sd_class}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{initData.sd_custprodcode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">产品名称</label>
            <span class="weui-form-preview__value">{{initData.sd_custproddetail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{initData.sd_custprodspec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">品牌</label>
            <span class="weui-form-preview__value">{{initData.sd_custprodbrand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">数量</label>
            <span class="weui-form-preview__value">{{initData.sd_qty}} {{ initData.sd_custprodunit }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户已验收数量</label>
            <span class="weui-form-preview__value">{{initData.sd_acceptqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">已出货数量</label>
            <span class="weui-form-preview__value">{{initData.sd_saleoutqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">交货日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{initData.sd_delivery}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">币别</label>
            <span class="weui-form-preview__value">{{initData.sd_currency}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">含税单价</label>
            <span class="weui-form-preview__value">{{initData.sd_price}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不含税单价</label>
            <span class="weui-form-preview__value">{{initData.sd_costprice}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">含税金额</label>
            <span class="weui-form-preview__value">{{initData.sd_total}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">不含税金额</label>
            <span class="weui-form-preview__value">{{initData.sd_taxtotal}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">返利率%</label>
            <span class="weui-form-preview__value">{{initData.sd_rebaterate}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">返利金额</label>
            <span class="weui-form-preview__value">{{initData.sd_rebateamount}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">抵扣金额</label>
            <span class="weui-form-preview__value">{{initData.sd_deductionamount}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft">
      <div class="weui-dialog__btn weui-dialog__btn_default" @click="onOpenReply">回复</div>
      <div class="weui-dialog__btn weui-dialog__btn_primary" v-if="initData.sd_turnstatus == '待接收'" @click="onAccept">接收</div>
      <div class="weui-dialog__btn weui-dialog__btn_primary" v-if="initData.sd_turnstatus == '待接收'" style="color: red;" @click="onOpenReject">拒绝</div>
    </div>

    <div v-if="showRejectInput">
      <div class="weui-mask weui-transition"></div>
      <div class="weui-half-screen-dialog weui-transition">
        <div class="weui-half-screen-dialog__hd">
          <div class="weui-half-screen-dialog__hd__main">
            <div class="weui-half-screen-dialog__title">拒绝原因</div>
            <!-- <div class="weui-half-screen-dialog__subtitle">{{ subtitle }}</div> -->
          </div>
        </div>
        <div
          class="weui-half-screen-dialog__bd"
          style="padding-top: 12px; height: 150px"
        >
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              rows="5"
              autofocus
              v-model="rejectReason"
              placeholder="请填写......"
              placeholder-class="weui-input__placeholder"
            />
          </div>
        </div>
        <div class="weui-half-screen-dialog__ft">
          <div class="weui-half-screen-dialog__btn-area">
            <div class="weui-btn weui-btn_primary" @click="onReject">确认</div>
            <div class="weui-btn weui-btn_default" @click="showRejectInput = false">取消</div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showReplyInput">
      <div class="weui-mask weui-transition"></div>
      <div class="weui-half-screen-dialog weui-transition">
        <div class="weui-half-screen-dialog__hd">
          <div class="weui-half-screen-dialog__hd__main">
            <div class="weui-half-screen-dialog__title">交期回复</div>
            <!-- <div class="weui-half-screen-dialog__subtitle">{{ subtitle }}</div> -->
          </div>
        </div>
        <div
          class="weui-half-screen-dialog__bd"
          style="padding-top: 12px; max-height: 230px; overflow-y: scroll;"
        >
          <div
            class="weui-cells__group"
            v-for="(item, xindex) in splitList"
            :key="xindex"
          >
            <div class="weui-cells__title">
              <span>批次{{ xindex + 1 }}</span>
              <a
                href="javascript:;"
                class="header-tool"
                @click="removeItem(xindex)"
              >
                <span>删除</span>
              </a>
            </div>
            <div class="weui-cell">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{"数量"}}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.qty"
                />
              </div>
            </div>
            <date-field
              :label="'交货日期'"
              v-model="item.delivery"
            />
            <a
              href="javascript:"
              v-if="xindex == splitList.length - 1"
              class="weui-cell weui-cell_link"
              @click="addItem"
            >
              <div class="weui-cell__bd">添加更多</div>
            </a>
          </div>
        </div>
        <div class="weui-half-screen-dialog__ft">
          <div class="weui-half-screen-dialog__btn-area">
            <div class="weui-btn weui-btn_primary" @click="onReply">确认</div>
            <div class="weui-btn weui-btn_default" @click="showReplyInput = false">取消</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateField from "@/components/field/DateField.vue";

export default {
  components: {
    DateField
  },
  props: {
    initData: Object
  },
  data() {
    return {
      showRejectInput: false,
      rejectReason: "",
      showReplyInput: false,
      splitList: [
        {
          delivery: "",
          qty: null
        }
      ]
    }
  },
  methods: {
    onOpenReply() {
      this.showReplyInput = true
    },
    onReply() {
      let me = this

      let jsonData = {
        pdid: me.initData.sd_pdid,
        pucode: me.initData.sd_pocode, 
        splitList: me.splitList, 
        type: 1
      }

      me.$loading({
        url: "/api/purchase/purchaseReply/save",
        method: "POST",
        jsonData
      }).then(function (res) {
        if (res.success) {
          me.$weui.toast("回复成功", 2000);
          me.showReplyInput = false
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    addItem() {
      var me = this,
        splitList = me.splitList;
      splitList.push({
        delivery: "",
        qty: null
      });
    },
    removeItem(i) {

      var me = this,
        splitList = me.splitList;

      if(splitList.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000)
        return
      }

      splitList.splice(i, 1);
    },
    onAccept() {
      let me = this

      let jsonData = {
        category: 20,
        customeruu: me.initData.sd_custuu, 
        pdid: me.initData.sd_pdid, 
        poid: me.initData.sd_poid 
      }

      me.$loading({
        url: "/api/sale/saledown/toAccept",
        method: "POST",
        jsonData
      }).then(function (res) {
        if (res.success) {
          me.$weui.toast("已成功接收", 2000);
          me.$router.back()
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    onOpenReject() {
      this.showRejectInput = true
    },
    onReject() {
      let me = this

      let jsonData = {
        custid: me.initData.sd_custid,
        custuu: me.initData.sd_custuu,
        fromCode: me.initData.sd_pocode,
        fromMainId: me.initData.sd_poid,
        fromType: "OsMake",
        reason: me.rejectReason
      }

      me.$loading({
        url: "/api/sale/saledown/reject",
        method: "POST",
        jsonData
      }).then(function (res) {
        if (res.success) {
          me.$weui.toast("已拒绝", 2000);
          me.$router.back()
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    }
  },
};
</script>